/**
 * RuleBuilderPage — entry for create/edit.
 *
 * Rebuilt as the guided 5-step wizard (RuleWizard), driven by the live
 * capability matrix (/meta/schema). The previous tab-based, mock-backed
 * builder has been retired.
 */
import RuleWizard from "./builder/RuleWizard";

export default RuleWizard;
